import React, { Component } from 'react'
import configs from '../../../configs.json'
import M from 'materialize-css';

class Hero extends Component {
    componentDidMount() {
        var elems     = document.querySelectorAll('.parallax');
        M.Parallax.init(elems, {});
    }
    render() {
        return (
            <div className="parallax-container" style={{height: '100vh'}}>
                <div className="parallax">
                    <img id="parallax-img"  alt='' src={require("../../../static/imgs/hero-bg.jpg")}/>
                    
                </div>
                <div className="section no-pad-bot">
                    <div className='hero-txt'>
                        <br/><br/>
                        <h1 className="header center text-lighten-2" style={{color:configs.colors.primary, textShadow: '3px 3px black'}} >{configs.hero.title}</h1>
                        <div className="row center">
                            <h4 className="header col s12 light white-text" style={{textShadow: '2px 2px black'}}>{configs.hero.description}</h4>
                        </div>
                        <br/>
                        <div className="row center">
                            <div className='col s6 right-align'>
                                <a href="#aboutus" id="hero-btn" className="btn-large waves-effect waves-light" style={{backgroundColor: configs.colors.secondary}}>Quem somos</a>
                            </div>
                            <div className='col s6  left-align'>
                                <a href="/login/" id="hero-btn" className="btn-large waves-effect waves-light" style={{backgroundColor: configs.colors.secondary}}>Entrar</a>
                            </div>
                        </div>
                        <br/><br/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Hero